// Batch-noyau picker for the bulk-add input screen. The whole batch shares one
// noyau (or "indéterminé"), which also becomes the downstream screen accent, so
// this is a single-select radio group: the six noyaux plus an explicit
// indéterminé option. Native radio inputs (visually hidden) back labelled pills,
// so keyboard + screen-reader behaviour is the browser's, not re-implemented.
import { NOYAU_DISPLAY_ORDER } from '@/lib/noyaux';
import type { NoyauCode } from '@/schemas/word';

interface NoyauPickerProps {
  value: NoyauCode | null;
  onChange: (value: NoyauCode | null) => void;
}

/** Single-select pill group choosing the batch noyau (null = indéterminé). */
export function NoyauPicker({ value, onChange }: NoyauPickerProps) {
  return (
    <div className="bulk-noyau-picker" role="radiogroup" aria-label="Noyau du lot">
      {NOYAU_DISPLAY_ORDER.map((noyau) => (
        <label
          key={noyau.code}
          className={`bulk-noyau-option bulk-noyau-option--${noyau.key}${value === noyau.code ? ' is-selected' : ''}`}
        >
          <input
            type="radio"
            name="bulk-noyau"
            className="bulk-noyau-option__input"
            checked={value === noyau.code}
            onChange={() => onChange(noyau.code)}
          />
          <span
            className={`bulk-noyau-option__dot words-noyau-dot--${noyau.key}`}
            aria-hidden="true"
          />
          {noyau.label}
        </label>
      ))}
      <label
        className={`bulk-noyau-option bulk-noyau-option--none${value === null ? ' is-selected' : ''}`}
      >
        <input
          type="radio"
          name="bulk-noyau"
          className="bulk-noyau-option__input"
          checked={value === null}
          onChange={() => onChange(null)}
        />
        <span className="bulk-noyau-option__dot words-noyau-dot--none" aria-hidden="true" />
        Aucun (indéterminé)
      </label>
    </div>
  );
}
